export const INCREMENT = "INCREMENT";
export const DECREMENT = "DECREMENT";

const incrementAction = data => {
	return {
		type: INCREMENT,
		payload: data
	};
};
const decrementAction = data => {
	return {
		type: INCREMENT,
		payload: data
	};
};
